import { render } from "./ExpedientViewer.vue?vue&type=template&id=6108aff0&scoped=true"
import script from "./ExpedientViewer.vue?vue&type=script&lang=js"
export * from "./ExpedientViewer.vue?vue&type=script&lang=js"

import "./ExpedientViewer.vue?vue&type=style&index=0&id=6108aff0&scoped=true&lang=css"

import exportComponent from "../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6108aff0"]])

export default __exports__